






















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {$} from 'simpli-web-sdk'
import {Action} from 'vuex-class'
import Carga from '@/model/resource/Carga'
import { CargaInfo2 } from '@/model/resource/CargaInfo2'

enum NotificationType {
  NOTIFY = 1,
  PRIORITIZE = 2,
}

@Component
export default class ModalNotification extends Vue {
  @Prop({type: Object, required: true}) carga!: Carga
  @Action('auth/auth') auth!: Function

  NotificationType = NotificationType
  isDisabled = false

  idTipoNotificacaoCarga: number = 1
  observacaoEntrega = ''

  close() {
    $.modal.close('modalNotification')
  }

  openEvent() {
    this.$emit('open')
  }

  closeEvent() {
    this.$emit('close')
  }

  get isButtonDisabled() {
    return this.isDisabled
  }

  async persistConfiguracao() {
    this.isDisabled = true
    if (!this.carga.idCargaPk) {
      return
    }

    const cargaInfo2 = new CargaInfo2()
    cargaInfo2.idCargaFk = this.carga.idCargaPk as number
    cargaInfo2.idTipoNotificacaoCargaFk = this.idTipoNotificacaoCarga
    cargaInfo2.observacaoEntrega = this.observacaoEntrega

    this.carga.cargaInfo2 = cargaInfo2

    try {
      await this.carga.persistTipoNotificacaoCarga(this.carga)
      this.$emit('updateCarga', cargaInfo2)
    } catch {
      // pass
    } finally {
      await this.auth
      this.close()
      this.isDisabled = false
    }

  }

  getButtonClass() {
    return this.isDisabled ? 'disabled-button' : 'primary'
  }
}
